<mat-chip-listbox multiple #chips class="custom-chip">
  @for (item of _items; track item; let index = $index) {
    <mat-chip-option
      [class.with-label]="item.label"
      [selected]="isSelected(item.value)"
      [disabled]="disabled"
      (click)="selectItem(item.value)"
      (keyup.space)="selectItem(item.value)"
      (keyup.enter)="selectItem(item.value)"
      >
      <fa-icon [icon]="['fas', 'check']"></fa-icon>
      <div class="item-container">
        @if (item.label) {
          <div class="body ellipsis noselect">
            {{ item.label }}
          </div>
        }
        <div
          class="body ellipsis noselect"
        [class.italic]="
          (translate && (item.display | transloco) === 'None') || item.display === 'None'
        "
          >
          {{ translate ? (item.display | transloco) : item.display }}
        </div>
      </div>
    </mat-chip-option>
  }
</mat-chip-listbox>
